import _asyncToGenerator from "/vercel/path0/node_modules/next/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
import _regeneratorRuntime from "/vercel/path0/node_modules/next/node_modules/@babel/runtime/regenerator";
import React, { useEffect } from 'react';
import moment from 'moment';
import { SessionList } from '../SessionList';
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
export var Schedule = function Schedule(_ref) {
  var getSchedule = _ref.getSchedule,
      schedules = _ref.schedules,
      providerService = _ref.providerService,
      showTitle = _ref.showTitle,
      cardShadow = _ref.cardShadow,
      createSession = _ref.createSession,
      excludeSession = _ref.excludeSession,
      classes = _ref.classes;
  var schedulesShown = excludeSession ? schedules.filter(function (s) {
    return s.sessionId !== excludeSession && s.activityId !== excludeSession;
  }) : schedules;

  var onSessionSelect = /*#__PURE__*/function () {
    var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(schedule) {
      var session, sessionUrl;
      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _context.next = 2;
              return createSession(schedule);

            case 2:
              session = _context.sent;

              if (session) {
                _context.next = 5;
                break;
              }

              return _context.abrupt("return");

            case 5:
              sessionUrl = "/".concat(providerService.provider.slug, "/sessions/").concat(session.slug);
              window.location.href = sessionUrl;

            case 7:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }));

    return function onSessionSelect(_x) {
      return _ref2.apply(this, arguments);
    };
  }();

  useEffect(function () {
    getSchedule({
      serviceId: providerService.id,
      startsAt: moment().subtract(60, 'minutes').toISOString(),
      endsAt: moment().add(3, 'month').toISOString()
    });
  }, [providerService]);
  return /*#__PURE__*/_jsx(_Fragment, {
    children: /*#__PURE__*/_jsx(SessionList, {
      schedules: schedulesShown,
      onSelect: onSessionSelect,
      showTitle: showTitle,
      cardShadow: cardShadow,
      classes: classes
    })
  });
};
Schedule.defaultProps = {
  showTitle: true,
  cardShadow: false
};